import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import PartnerTableView from './components/PartnerTableView';
import PartnerWithTransactionTableView from './components/PartnerWithTransactionTableView';
import { change_popup_details_view_state } from './actions';
import { getPopUpDetailsStatus } from './reducers';
import {
  getFilteringState,
  getPartners,
  getPartnersWithTransaction
} from '../reducers';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content'
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120
  },
  formControlLabel: {
    marginTop: theme.spacing.unit
  }
});

const renderTableView = (filteringState, data = {}) => {
  if (filteringState.partner_update && data.partners)
    return <PartnerTableView list={data.partners} />;
  else if (filteringState.partner_transaction && data.partners_with_transaction)
    return (
      <PartnerWithTransactionTableView list={data.partners_with_transaction} />
    );
};

const MaxWidthDialog = props => {
  const open = useSelector(getPopUpDetailsStatus);
  const filteringState = useSelector(getFilteringState);
  const partners = useSelector(getPartners);
  const partners_with_transaction = useSelector(getPartnersWithTransaction);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(change_popup_details_view_state(false));
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {renderTableView(filteringState, {
          partners,
          partners_with_transaction
        })}
        <DialogActions>
          <Button
            variant="contained"
            style={{ background: 'red', color: 'white' }}
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MaxWidthDialog);
